"use client";
import styled from "../../../client-utils/styled/index.js";
import shouldForwardProp from "../../../client-utils/styled/shouldForwardProp.util.js";
import isString from "../../../common-utils/string/isString.util.js";
import Box from "../../../components/atoms/Box/index.js";
export const StyledSpacer = styled(Box, {
    name: "SdbSpacer",
    slot: "Root",
    shouldForwardProp: shouldForwardProp("spacing", "px", "direction"),
})(({ direction, spacing, px, theme }) => ({
    ...(direction === "horizontal"
        ? {
            width: spacing ? theme.spacing(spacing) : isString(px) ? px : `${px}px`,
        }
        : {
            minHeight: spacing ? theme.spacing(spacing) : isString(px) ? px : `${px}px`,
        }),
}));
